import { AttachedDocumentTableModel } from './../../models/attached-document-table-model';
import { OnbaseDoc } from 'src/app/models/onbase-doc';
import { OnbaseProcedureResponseModel } from 'src/app/models/response/onbaseProcedureResponseModel';
import { CreditRequestRequirement } from 'src/app/models/credit-request-requirements';
import { PosCreditRequestRequirementDetailComponent } from './../../shared/pos-credit-request-requirement-detail/pos-credit-request-requirement-detail.component';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogType } from '../constants';
import { CreditRequest } from 'src/app/models/credit-request';

@Injectable({
  providedIn: 'root',
})
export class PosCreditRequestRequirementDetailModalService {
  private modalRef: BsModalRef<PosCreditRequestRequirementDetailComponent> = new BsModalRef();
  constructor(private modalService: BsModalService) { }

  async show(
    requirement: CreditRequestRequirement,
    creditPlan: OnbaseProcedureResponseModel,
    onbaseDocs: Array<OnbaseDoc>,
    creditRequest: CreditRequest
  ): Promise<
    { comment: string; files: Array<AttachedDocumentTableModel> } | undefined
  > {
    this.modalRef = this.modalService.show(
      PosCreditRequestRequirementDetailComponent,
      {
        class: `modal-dialog modal-md modal-dialog-scrollable ${ModalDialogType.PRIMARY}`,
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
        animated: true,
        initialState: {
          requirement,
          creditPlan,
          onbaseDocs,
          creditRequest,
        },
      }
    );

    return this.modalRef.content?.requirementConfirmed.toPromise();
  }
}
